const PlayVideoIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            fill="#C8C8C8"
            version="1.1"
            viewBox="0 0 490.718 490.718"
        >
            <path d="M245.359.359C109.852.359 0 110.049 0 245.358s109.852 245 245.359 245 245.359-109.691 245.359-245S380.866.359 245.359.359m-68.531 340.652V140.824l187.489 100.098z"></path>
        </svg>
    )
}
export default PlayVideoIcon;